import React, { useState } from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import Sidebar from "./Sidebar"
import { Col, Container, Row } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"
import DownloadBox from "./DownloadBox"
import CallToAction from "../CallToAction"
import CarrierSlider from "../../carrier/CarrierSlider"

const Overview = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleContent = () => {
    setIsOpen(!isOpen) // Schaltet den Zustand um
  }

  const data = useStaticQuery(graphql`
          query CarrierauswahlHomepageQuery {
            carriers: allMarkdownRemark(
              filter: {fields: {collection: {eq: "carriers"}}, frontmatter: {active: {eq: true}}}
              ) {
              edges {
                node {
                  id
                  frontmatter {
                    active
                    carrier_support_email
                    carrier_name
                  }
                  fields {
                    collection
                    slug
                  }
                }
              }
            }
          }`)

  return (
    <>
      <section className="services-details-area ptb-100">
        <Container className="mt-5">
          <Row>
            <Col lg={8} md={12}>
              <div className="services-details-image">
                <StaticImage
                  src="../../../assets/images/products/netversys/devices/nv_dashboard_devices_all.png"
                  alt="NETVERSYS - Versandlogistiksoftware für Unternehmen"
                  placeholder="blurred"
                  width={900}
                />
              </div>

              <span className="products-sub-title" data-nosnippet="true">Versandsoftware</span>
              <h1 className={"pt-3"}>NETVERSYS - Multicarrier-Versand für Profis</h1>
              <p>
                Die Multicarrier-Versandsoftware, die Ihre Sprache spricht und Tempomacher ihrer Geschäfte ist: Klar,
                umfassend, leistungsstark, dank moderner Webtechnologien skaliert auf Ihre Logistikstrukturen und
                Versandvolumen. Nutzen Sie alle Optionen und Services, um weltweit schneller und wirtschaftlicher zu
                versenden.
              </p>
              <p>Mit NETVERSYS profitieren Sie von der Expertise sowie Service- und Preisvorteilen vieler Carrier, ohne
                deren Schnittstellen aufwändig an Ihre Systeme anzubinden. Unser Versandsystem stellt Daten und
                Dokumente passgenau allen Versand- und Geschäftsprozessen bereit, lichtet den Dschungel aus Services,
                vereinheitlicht die Sendungsverfolgung und rechnet unkompliziert ab.</p>

              <h2>Automatisierte Best-Carrier-Auswahl</h2>
              <p>
                Mehr als 50 im Standard angebundene Frachtführer plus eigenständig implementierbare Custom Carrier: Die
                intelligente Auswahl kann nach kundenindividuellen Regeln fallen, passt sich dank flexibler
                Webtechnologien,
                intuitiver Nutzeroberfläche und Plugin-System jedem Unternehmen an. Alle Arten von Waren erreichen
                günstig und schnell ihr Ziel – z.B. zum günstigsten Entgelt, zu bestimmten Uhrzeiten und mit dem auf
                Fracht und Zielregion spezialisierten Stückgut- oder KEP-Frachtführer.
              </p>
              <p>
                Selbstverständlich nahtlos integriert mit Vorsystemen und Hardware wie Etikettendrucker und
                Applizierdrucker, inklusive zentraler Sendungsverfolgung aller gängigen Carrier und personalisierter
                Benachrichtigungen für Sender und Empfänger, Zolldatentransfer, rechtskonformer Gefahrguthandhabung und
                automatisierter Tagesabschlüsse. NETVERSYS bietet die Sendungskompression, führt einzelne Sendungen an
                den gleichen Empfänger zu einer einzigen zusammen. Das Rollen- und Rechtemanagement
                individualisiert das Versandsystem für jeden Mitarbeiter.
              </p>
              <p>
                Einfach versenden und klar sehen: Wir kennen die Kernanforderungen, meistgenutzten Carrier und Services,
                gießen unser Know-how seit mehr als 20 Jahren in eine serverbasierte und leicht anzupassende
                Business-Versandlösung für alle Systeme.
              </p>
              <p className="text-highlight"><strong>
                Mit NETVERSYS wird Versand so schnell, einfach, effizient und günstig wie nie.</strong>
              </p>
              <h2>Die Idee, die Ihre Pakete trägt</h2>
              <p>
                2003 begann die Erfolgsstory unserer Versandsoftware, mit der sich der Versand auf einer Plattform
                verwalten, steuern und auf Wunsch vollautomatisch im <Link
                to="/versandsoftware/netversys/blackbox-modus">Blackbox-Modus</Link> abwickeln lässt. Wir haben als eine
                der ersten Software-Unternehmen eine webbasierte, cloudfähige Lösung angeboten und sie konsequent
                weiterentwickelt.
              </p>
              <p>Modernste serverbasierte <Link to="/technologie">Technologien</Link>, ein kompetentes Team
                für schnelle Entwicklung und
                Support sorgen dafür, dass alle NETVERSYS-Nutzer von den regelmäßigen Updates, technischen
                Verbesserungen und der wachsenden Auswahl an Carriern und Services profitieren.
              </p>
              <p><Link to="/kundenprojekte/" className="text-primary"> <i className="bx bx-chevron-right" />Zu unseren
                Kundenprojekten</Link></p>
              <p>Die Releasefähigkeit, das Plugin-System, das die Kernfunktionen problemlos um unternehmensspezifische
                Prozesse erweitert, die nahtlose Anbindung an unser leistungsstarkes <Link to="/lagerverwaltung/">Lagerverwaltungssystem
                  NETSTORSYS</Link> &nbsp;
                und die umfangreichen Features, die wir laufend in enger Kundenkooperation entwickeln, machen unser
                Versandsoftware so besonders.</p>
              <div style={{ marginTop: "2em", marginBottom: "-2em" }}>
                <CallToAction text={"Jetzt beraten lassen"} link={"/kontakt"}></CallToAction>
              </div>
            </Col>

            <Col lg={4} md={12}>
              <Sidebar />
            </Col>
          </Row>
        </Container>
      </section>
      <CarrierSlider />
      {/* Feature Highlight 1 */}
      <section className={"services-area netstorsys-fh bg-f1f8fb product-details netversys-fh1"} id="konfiguration">
        <Container>
          <span className="mb-2 text-primary"><i className={"bx bxs-star"} /> Stemmt jede Peak-Saison</span>
          <h2>{"Hohe Auftragsvolumen optimal versenden"}</h2>
          <p>
            Aus Erfahrung nutzen unsere Kunden einige zentrale NETVERSYS-Funktionen besonders intensiv, die für den
            erfolgreichen Versand umfangreicher Aufträge essentiell sind. Wir haben sie besonders benutzerfreundlich und
            mächtig gemacht. Mit hoher Individualisierbarkeit lassen sie sich auf jeden Bedarf feinjustieren.
          </p>
          <div className="configurations-section">
            <ul className={"fa-ul"}>
              <Row style={{ paddingLeft: 0 }}>
                <Col xs={12} lg={{ span: 6 }}>
                  <li>
                    <span className={"fa-li"}><i style={{ fontSize: "2em" }}
                                                 className={"bx bx-check text-primary"} /></span>
                    <span className="bullet-point-title"
                          style={{ fontWeight: "bolder" }}>Regelbasierte Carrierauswahl</span>
                    <div className="bullet-point-text">Gewicht und Maße, Zielort, Lieferzeit, Versandkosten,
                      Serviceleistungen, Versandart oder
                      Prioritäten – abhängig von definierten Regeln wie Art und Ziel der Sendung oder verfügbaren
                      Optionen sucht NETVERSYS automatisch den besten Carrier, um Kosten und Zeit am Versandplatz und
                      beim Versand zu sparen. Wir integrieren laufend weitere Carrier.
                    </div>
                    <div className="bullet-point-link">
                      <Link style={{ textDecoration: "underline", fontSize: "16px" }}
                            to={"/versandsoftware/netversys/multi-carrier/"}>Multi-Carrier</Link>
                    </div>
                  </li>

                  <li>
                    <span className={"fa-li"}><i style={{ fontSize: "2em" }}
                                                 className={"bx bx-check text-primary"} /></span>
                    <span style={{ fontWeight: "bolder" }}
                          className="bullet-point-title">Track & Trace</span>
                    <div className="bullet-point-text">
                      Eine umständliche Sendungsverfolgung auf den Internetseiten der einzelnen Frachtführer ist
                      überflüssig. Sendungen der gängigen Carrier lassen sich über eine zentrale Maske verfolgen. Die zu
                      Sendungsnummern passenden Carrier identifiziert NETVERSYS automatisch.
                    </div>
                    <div className="bullet-point-link">
                      <Link style={{ textDecoration: "underline" }}
                            to={"/versandsoftware/netversys/tracktrace/"}>Track & Trace</Link>
                    </div>
                  </li>
                  <li>
                    <span className={"fa-li"}><i style={{ fontSize: "2em" }}
                                                 className={"bx bx-check text-primary"} /></span>
                    <span style={{ fontWeight: "bolder" }} className="bullet-point-title">Hardware-Integration</span>
                    <div className="bullet-point-text">
                      NETVERSYS übernimmt Maße und Gewichte und druckt das passende Versandlabel zum ausgewählten
                      Frachtführer automatisch aus. Dazu lässt sich typische Versandstraßen-Hardware wie Waagen,
                      Labeldrucker und Applizierdrucker einbinden.
                    </div>
                    <div className="bullet-point-link">
                      <Link style={{ textDecoration: "underline", fontSize: "16px" }}
                            to={"/barcode/"}>Lexikon: Barcode</Link>
                    </div>
                  </li>
                  <li>
                    <span className={"fa-li"}><i style={{ fontSize: "2em" }}
                                                 className={"bx bx-check text-primary"} /></span>
                    <span style={{ fontWeight: "bolder" }}
                          className="bullet-point-title">Schneller Gefahrgutversand</span>
                    <div className="bullet-point-text"> NETVERSYS bieten den ADR-konformen Gefahrgutversand inklusive
                      aller notwendigen Etiketten, Dokumente und Daten. Versenden Sie Gefahrgut sicher und schnell mit
                      den darauf spezialisierten Frachtführern.
                    </div>
                    <div className="bullet-point-link">
                      Lexikon: &nbsp;
                      <Link to={"/gefahrgutsendung/"}>Gefahrgutsendung</Link>,&nbsp;
                      <Link to={"/adr/"}>ADR</Link>&nbsp;
                    </div>
                  </li>
                </Col>
                <Col xs={12} lg={{ span: 6 }}>

                  <li>
                    <span className={"fa-li"}><i style={{ fontSize: "2em" }}
                                                 className={"bx bx-check text-primary"} /></span>
                    <span style={{ fontWeight: "bolder" }} className="bullet-point-title">Personalisierte Versand-E-Mails</span>
                    <div className="bullet-point-text"> Personalisierte Versand- und Status-E-Mails, gebrandet und im
                      Corporate Design Ihres
                      Unternehmens,
                      halten Sender und Empfänger in Echtzeit über den Sendungsstatus auf dem Laufenden. Automatische
                      E-Mails weisen auf Ereignisse hin, enthalten z.B. Versandbestätigung, Liefertermin,
                      Abholungshinweis, Retoure-Erinnerung und Bewertungsaufforderung.
                    </div>
                    <div className="bullet-point-link">
                      <Link
                        to={"/versandsoftware/netversys/versandemails/"}>Versand-E-Mails</Link>
                    </div>
                  </li>
                  <li>
                    <span className={"fa-li"}><i style={{ fontSize: "2em" }}
                                                 className={"bx bx-check text-primary"} /></span>
                    <span style={{ fontWeight: "bolder" }} className="bullet-point-title">Black-Box-Modus</span>
                    <div className="bullet-point-text"> NETVERSYS kann vollständig automatisiert und in ein bestehendes
                      Logistiksystem eingebunden
                      werden,
                      ohne direkte Interaktion mit der Nutzeroberfläche. Vorsysteme interagieren dabei mit der Software
                      und tauschen Daten aus.
                    </div>
                    <div className="bullet-point-link">
                      <Link to={"/versandsoftware/netversys/blackbox-modus"}>Blackbox-Modus</Link>, &nbsp;
                      <Link to={"/referenz/wortmann-ag/"}> Kundenprojekt Wortmann AG</Link>
                    </div>
                  </li>

                  <li>
                    <span className={"fa-li"}><i style={{ fontSize: "2em" }}
                                                 className={"bx bx-check text-primary"} /></span>
                    <span className="bullet-point-title"
                          style={{ fontWeight: "bolder" }}>Eigene Carrier integrieren</span>
                    <div className="bullet-point-text">Egal ob Stückgut- oder KEP-Frachtführer – wenn der eigene
                      Fuhrpark oder kleine Carrier noch fehlen, können Nutzer sie als Custom Carrier über eine intuitive
                      Eingabemaske mit eigenen Label-Templates selbst implementieren und wie die im Standard
                      angebundenen Carrier nutzen – wahlweise als Carrier oder <Link
                        to={"/cmr-carrier/"} style={{ textDecoration: "underline" }}>CMR-Carrier</Link> inklusive
                      Frachtbrief-Druck.
                    </div>
                  </li>
                  <li>
                    <span className={"fa-li"}><i style={{ fontSize: "2em" }}
                                                 className={"bx bx-check text-primary"} /></span>
                    <span style={{ fontWeight: "bolder" }}
                          className="bullet-point-title">Daten für Geschäftsprozesse</span>
                    <div className="bullet-point-text"> NETVERSYS setzt auf robuste RESTful-APIs, leichtgewichtige
                      HTTP-Methoden, einfach zu parsende
                      Datenaustauschformate und EDI-Standards. Daten werden sicher, schnell und zuverlässig anderen
                      Systemen bereitgestellt, hochperformant und ressourcensparsam.
                    </div>
                    <div className="bullet-point-link">
                      <Link style={{ textDecoration: "underline", fontSize: "16px" }}
                            to={"/versandsoftware/netversys/daten-fuer-geschaeftsprozesse"}>Daten für
                        Geschäftsprozesse</Link>
                    </div>
                  </li>
                </Col>
              </Row>
            </ul>
          </div>
        </Container>
      </section>

      {/* Feature Highlight 2 */}
      <section className="services-area netstorsys-fh netversys-fh2 bg-fffbf5">
        <Container>
          <span className="mb-2 text-primary"><i className={"bx bxs-star"} /> Plug & Play für jeden Versand</span>
          <h2>Modernste App-Programmierung</h2>
          <Row>
            <Col sm={12} lg={{ span: 6 }} style={{ display: "flex" }} className="fh-image-container">
              <StaticImage
                src="../../../assets/images/products/netversys/overview/netversys_map.png"
                alt="Netversys Map"
                placeholder="blurred"
                width={500}
              />
            </Col>
            <Col lg={6} className="fh-text-container">
              <p>
                NETVERSYS nutzt aktuelle <Link to="/technologie">Technologien</Link>, um die Anwendung schneller und
                kostengünstiger zu entwickeln,
                flexibel für alle Anforderungen zu erweitern und durch Releasefähigkeit laufend auf dem neuesten Stand
                zu halten.
              </p>
              <p>
                Dank des mächtigen <Link to="/versandsoftware/netversys/plugins/">Plugin-Systems</Link> und der Listener
                lässt
                sich das Versandsystem wahlweise an jedes Vorsystem
                anbinden, um Daten automatisch zu übernehmen, oder ermöglicht, Sendungsdaten manuell einzugeben. Es ist
                um unternehmensspezifische Funktionen und Dialoge erweiterbar und prozessgenau anpassbar, ohne
                Beeinträchtigung des Kernsystems und seiner Updatefähigkeit.
              </p>
              <p className="text-highlight"><strong>Entscheiden Sie, ob das Versandsystem <Link
                to="/on-premises/">On-Premises</Link> oder als
                Anwendung in
                der Cloud läuft – NETVERSYS
                kann beides.</strong></p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Feature Highlight 3 */}
      <section className="services-area bg-f1f8fb ptb-100">
        <Container>
          <Row>
            <Col lg={11}>
              <h2>Extras inbegriffen</h2>
              <p>Auf diesem tragfähigen Tech-Fundament bieten wir etliche weitere Funktionen, die über die häufig
                genutzten Kern-Features hinausgehen. Sie machen den Versand noch flexibler und komfortabler. </p>
              <p>Dazu gehören das <strong>Mandantensystem</strong>, um Kunden, Abrechnungen und Sendungen transparent zu
                verwalten und jedes
                Unternehmen virtuell abzubilden, automatisierte <strong>Tagesabschlüsse</strong>, die nachträgliche
                Korrekturen und
                Stornierungen ermöglichen, detaillierte <strong>Paketrecherche</strong> mit
                Filterfunktion, <strong>ZPL-Viewer </strong>
                zu Analyse und
                Modifikation fehlerhafter Etiketten sowie der Versand über <strong>CMR-Carrier</strong>.
                <strong> Versandstatistiken</strong> lassen sich
                in übersichtlichen Dashboards anzeigen und exportieren. </p>
              <p>Versanddaten lassen sich aus beliebigen Vorsystemen in <strong>Auftragspools</strong> übertragen, von
                der
                Versandabwicklung entkoppeln und als <strong>Reverse-Colli/ OnHold</strong> für einen späteren Versand
                modifizieren.
                Bestimmte Tage können per <strong>Wochentagssperre</strong> für den Versand gesperrt, genaue
                Abholinformationen als
                detaillierte <strong>Verladeorte</strong> eingegeben werden. </p>
              <p>Die <strong>Verwaltung</strong> von individuell ausgehandelten <strong>Entgelten</strong>, von
                Geschenken über den
                <strong> Gift-with-Purchase-Manager</strong> mit individuellen Regeln zu Bestellmengen oder
                Sonderaktionen, die Verwaltung
                von <strong>Global Location Numbers (GLN)</strong> und <strong>Nummernkreisen</strong> wie fortlaufenden
                Sendungsnummern,
                Rechnungsnummern, Retourennummern oder Auftragsnummern macht NETVERSYS maximal flexibel.</p>
              <p>Im responsiven <strong>Leitstand</strong> pflegt der Teamleiter Versandlogistik Mandanten, definiert
                Regeln und ordnet
                Carrier zu. So lassen sich verschiedene Organisationsstrukturen abbilden. Über
                den <strong>Dokumentenmanager </strong>
                haben die Mitarbeiter, je nach Rollen und Rechten, jederzeit Zugriff auf Dokumente wie
                Einlieferungslisten, Abrechnungen oder Gefahrgutformulare.</p>
            </Col>
          </Row>
        </Container>

      </section>

      {/* Feature Highlight 4 */}
      <section className="services-area netstorsys-fh netversys-fh2">
        <Container>
          <span className="mb-2 text-primary"><i className={"bx bxs-star"} /> Optimal Lagern</span>
          <h2>Integriertes Warehouse Management</h2>
          <Row>
            <Col sm={12} lg={6} style={{ display: "flex", justifyContent: "center" }} className="fh-image-container">
              <StaticImage
                src="../../../assets/images/products/netstorsys/wm-warehousetimeline.svg"
                alt="Warehouse Management"
                placeholder="blurred"
                width={400}
              />
            </Col>
            <Col lg={6} className="fh-text-container">
              <p> Denken Sie erfolgreiche Lagerverwaltung und reibungslosen Versand zusammen: Durch nahtlose Integration
                unseres Multicarrier-Versandsystems NETVERSYS mit unserem Warehouse Management System NETSTORSYS
                versenden Sie Ihre Waren direkt aus Ihrem Lager, ohne Systeme wechseln zu müssen. Sparen Sie Zeit und
                minimieren Sie mögliche Bedienfehler! Managen Sie mit NETVERSYS den erfolgreichen und wirtschaftlichen
                Versand – und sorgen Sie mit einem flexiblen, modernen WMS für E-Commerce, Händler,
                Logistikdienstleister und Hersteller dafür, dass die Ware pünktlich an der Verladerampe steht.</p>
              <div style={{ marginTop: "2em" }}>
                <CallToAction text={"Warehouse Management"} link={"/lagerverwaltung"}></CallToAction>
              </div>
            </Col>

          </Row>
        </Container>
      </section>

      <section className="services-details-area d-lg-none">
        <div className="services-details-info p-5">
          <DownloadBox />
        </div>
      </section>
    </>
  )
}

export default Overview
